import { useEffect, useState } from 'react';

export const REVEAL_ATTRIBUTE = 'data-sbf-reveal';
export const REVEALED_ATTRIBUTE = 'data-sbf-revealed';

/**
 * Marks each `[data-sbf-reveal]` section inside `rootRef` as revealed the first
 * time it scrolls into view, which triggers its CSS entrance animation.
 * Returns whether the reveal is active: without IntersectionObserver it stays
 * false, so the footer's hidden starting state never applies and the content
 * is simply shown.
 */
export function useFooterReveal(rootRef) {
  const [isRevealActive, setIsRevealActive] = useState(false);

  useEffect(() => {
    const root = rootRef.current;
    if (!root || typeof window.IntersectionObserver !== 'function') {
      return undefined;
    }

    const observer = new window.IntersectionObserver(
      (entries) => {
        entries.forEach(({ isIntersecting, target }) => {
          if (isIntersecting) {
            target.setAttribute(REVEALED_ATTRIBUTE, 'true');
            observer.unobserve(target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }
    );

    root
      .querySelectorAll(`[${REVEAL_ATTRIBUTE}]`)
      .forEach((section) => observer.observe(section));
    setIsRevealActive(true);

    return () => observer.disconnect();
  }, [rootRef]);

  return isRevealActive;
}
